import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import siteLogo from "@/assets/logo-nathalie-barach.png";
import logoBto from "@/assets/logo-bto-blanc.webp";

const SiteFooter = () => {
  const { pathname } = useLocation();
  const scrollIfSame = (to: string) => () => { if (pathname === to) window.scrollTo(0, 0); };
  return (
  <footer className="bg-primary text-primary-foreground">
    <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
      {/* Brand */}
      <div className="flex flex-col items-center md:items-start gap-3">
        <Link to="/" onClick={scrollIfSame("/")} className="flex flex-col items-center md:items-start gap-3">
          <img src={siteLogo} alt="Nathalie Barach" loading="lazy" decoding="async" width="64" height="64" className="h-16 w-16 rounded-full object-cover" />
          <p className="font-heading text-xl font-bold">Nathalie Barach</p>
        </Link>
        <p className="font-body text-primary-foreground/70 text-sm text-center md:text-left">
          Hypnothérapeute & Coach — Hypnose · DTMA · Coaching
        </p>
      </div>

      {/* Navigation */}
      <div className="flex flex-col items-center md:items-start gap-2">
        <h4 className="font-heading text-lg font-semibold mb-2">Navigation</h4>
        {[
          { label: "Accueil", to: "/" },
          { label: "À propos", to: "/a-propos" },
          { label: "Arrêter le tabac", to: "/arreter-le-tabac" },
          { label: "Thérapies", to: "/therapies" },
          { label: "Blog", to: "/blog" },
          { label: "Guide arrêt du tabac", to: "/arreter-le-tabac/guide-complet" },
          { label: "Guide hypnose", to: "/hypnose/guide-complet" },
          { label: "Guide coaching", to: "/coaching/guide-complet" },
          { label: "FAQ", to: "/faq" },
          { label: "Contact", to: "/contact" },
        ].map((l) => (
          <Link key={l.to} to={l.to} onClick={scrollIfSame(l.to)} className="font-body text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
            {l.label}
          </Link>
        ))}
      </div>

      {/* Contact */}
      <div className="flex flex-col items-center md:items-start gap-3">
        <h4 className="font-heading text-lg font-semibold mb-2">Contact</h4>
        <a href="tel:+33628436977" className="flex items-center gap-2 font-body text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
          <Phone size={16} /> 06 28 43 69 77
        </a>
        <a href="mailto:nathalie.barach@outlook.fr" className="flex items-center gap-2 font-body text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
          <Mail size={16} /> nathalie.barach@outlook.fr
        </a>
        <a href="https://maps.app.goo.gl/gQbNEsYZANeaTEzD6" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 font-body text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
          <MapPin size={16} /> 15 rue Charles de Gaulle, 89250 Chemilly-sur-Yonne
        </a>
      </div>
    </div>

    {/* Bottom bar */}
    <div className="border-t border-primary-foreground/10">
      <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col items-center gap-3 text-xs font-body text-primary-foreground/40">
        <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-2">
          <p>© {new Date().getFullYear()} Nathalie Barach. Tous droits réservés.</p>
          <div className="flex items-center gap-4">
            <Link to="/mentions-legales" className="hover:text-primary-foreground/60 transition-colors">Mentions légales</Link>
            <Link to="/politique-de-confidentialite" className="hover:text-primary-foreground/60 transition-colors">Politique de confidentialité</Link>
          </div>
          <a href="https://b-to.io/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 hover:text-primary-foreground/60 transition-colors">
            Site réalisé par <img src={logoBto} alt="B-to" loading="lazy" decoding="async" className="h-6 inline-block object-contain" />
          </a>
        </div>
      </div>
    </div>
  </footer>
  );
};

export default SiteFooter;
